const fclImportChargesData = {
    colNames : {
        twoSpan: '',
        twoSpan1: 'Per Container',
        twoSpan2: '',
        perShipment: 'Per BL'
    },
    initialLength: 13,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            currency: '',
            onaccount: "On Your Account",
            disabled: ['perShipment']
        },
        {
            id: 2,
            chargeDescription: 'Origin Customs Clearance',
            currency: '',
            onaccount: "On Your Account",
            disabled: ['perShipment']
        },
        {
            id: 3,
            chargeDescription: 'Origin Charges',
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 4,
            chargeDescription: 'Origin Inland Haulage',
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 5,
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            onaccount: "On Your Account",
            // disabled: ['perShipment']
        },
        {
            id: 6,
            chargeDescription: 'Hazardous Surcharge',
            currency: 'USD',
            disabled: ['perShipment'],
            onaccount: "On Your Account",
        },
        {
            id: 7,
            chargeDescription: 'Destination Inland Haulage',
            currency: '',
            disabled: ['perShipment'],
            onaccount: "On Your Account",
        },
        {
            id: 8,
            chargeDescription: 'Destination Charges',
            currency: 'INR',
            onaccount: "On Your Account",
        },
        {
            id: 9,
            chargeDescription: 'Destination Terminal Charges',
            currency: 'INR',
            onaccount: "On Your Account",
        },
        {
            id: 10,
            chargeDescription: 'Destination Customs Clearance',
            currency: 'INR',
            onaccount: "On Your Account",
        },
        {
            id: 11,
            chargeDescription: 'Delivery Charges',
            currency: 'INR',
            onaccount: "On Your Account",
        },{
            id: 12,
            chargeDescription: 'Terminal Handling Fees',
            currency: '',
            onaccount: "On Your Account",
            disabled: ['perShipment']
        },{
            id: 13,
            chargeDescription: 'BL Fees',
            currency: '',
            onaccount: "On Your Account",
            disabled: ['perShipment']
        }
    ]
}
export default fclImportChargesData